import { ChartNoAxesCombined, Monitor } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuItem } from "@nexus/ui";
import {
  buildEventWorkspaceHref,
  getMonitorProtection,
  type EventWorkspaceView,
} from "../eventWorkspaceNavigation";

interface Props {
  view: EventWorkspaceView;
  eventId: string | null;
}

export function EventViewNavigation({ view, eventId }: Props) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const protectionId = getMonitorProtection(view, search);
  const destination = view === "monitor" ? "overview" : "monitor";
  const label = view === "monitor" ? "All tenants" : "Per tenant";

  return (
    <MenuItem
      onSelect={() => navigate(buildEventWorkspaceHref(destination, eventId, protectionId))}
      title={
        view === "monitor"
          ? "Compare this event across all authorized tenants"
          : "Inspect this event in the selected tenant"
      }
    >
      {view === "monitor" ? (
        <ChartNoAxesCombined className="size-4" aria-hidden />
      ) : (
        <Monitor className="size-4" aria-hidden />
      )}
      {label}
    </MenuItem>
  );
}
